const deltaMap = new Map([[-1, "negative"], [0, "neutral"], [1, "positive"]]);

function deltaType(value, reverseCoefficient = 1) {
  return deltaMap.get(Math.sign(reverseCoefficient * value));
}

function reverseDeltaType(value) {
  return deltaType(value, -1);
}

module.exports.deltaType = deltaType;
module.exports.reverseDeltaType = reverseDeltaType;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/util/delta-type.js